import { PaletteMode, PaletteOptions } from '@mui/material';

export class PaletteOverride {
  static mode: PaletteMode = 'dark';

  static grey = {
    900: '#080808',
    800: '#1E1E1E',
    700: '#383838',
    600: '#666666',
    500: '#808080',
    400: '#999999',
    300: '#B3B3B3',
    200: '#CCCCCC',
    100: '#e6e6e6',
    50: '#fafafa',
  };

  static primary = {
    main: '#26f7c5',
    dark: '#1ec69e',
    darker: '#179476',
    light: '#93fbe2',
    lighter: '#befdee',
    contrastText: PaletteOverride.grey[900],
  };

  static secondary = {
    main: '#8895fa',
    dark: '#6d77c8',
    darker: '#525996',
    darkest: '#52599640',
    light: '#CFCAFD',
    lighter: '#D8DBFE',
    contrastText: PaletteOverride.grey[50],
  };

  static warning = {
    main: '#F2C118',
    light: '#FFE84A',
    dark: '#C09500',
  };

  static error = {
    main: '#F24F18',
    light: '#FF7351',
    dark: '#A72E0F',
  };

  static info = {
    main: '#0288D1',
    light: '#3CA6FF',
    dark: '#0063A7',
  };

  static success = {
    main: '#2E7D32',
    light: '#4CA64A',
    dark: '#1F5E22',
  };

  static common = {
    black: PaletteOverride.grey[900],
    white: PaletteOverride.grey[50],
  };
}

const palette: PaletteOptions = {
  mode: PaletteOverride.mode,
  grey: PaletteOverride.grey,
  primary: PaletteOverride.primary,
  secondary: PaletteOverride.secondary,
  warning: PaletteOverride.warning,
  error: PaletteOverride.error,
  info: PaletteOverride.info,
  success: PaletteOverride.success,
  common: PaletteOverride.common,
};

export default palette;
